import { render } from "./CustomSocialsShare.vue?vue&type=template&id=bdcfcdf2&scoped=true"
import script from "./CustomSocialsShare.vue?vue&type=script&lang=js"
export * from "./CustomSocialsShare.vue?vue&type=script&lang=js"

import "./CustomSocialsShare.vue?vue&type=style&index=0&id=bdcfcdf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdcfcdf2"]])

export default __exports__